<template>
  <div>
    <div class="mainContent startContactDiv">

      <div class="mainContent__paragraphs">
        <p>
          Informe seu(s) o(s) contato(s) na transportadora, geralmente é o responsável pela sua conta ou comercial da transportadora.
        </p>
        <p>
          Esse contato vai receber os dados para configurar a integração com a Intelipost.
        </p>
      </div>

      <div class="mainContent__inputs">

        <div class="mainContent__inputs__fullname">
          <label for="fullname">
            <strong>Nome Completo:</strong>
          </label>
          <sc-input v-model="fullname"></sc-input>
        </div>

        <div class="mainContent__inputs__email">
          <label for="email">
            <strong>Email  de contato na transportadora:</strong>
          </label>
          <sc-field
            :message="emailValidationMessage()"
            :type="emailValidationMessage() ? 'is-danger' : ''"
            >
            <sc-input v-model="email" @input="onChangeEmail()"></sc-input>
          </sc-field>
        </div>

        <div class="mainContent__inputs__phone">
          <label for="phone">
            <strong>Telefone:</strong>
          </label>
          <sc-input type="phone" v-mask="'(##) #####-####'" v-model="phone"></sc-input>
        </div>
      </div>
    </div>
    <help-button/>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScField,
    ScInput,
    ScToast,
} from '@intelipost-js/secure-components';
import { mask } from 'vue-the-mask';
import HelpButton from './base/HelpButton.vue';

  const { mapActions, mapMutations } = createNamespacedHelpers('integrations/integrationsAppSelfService');
  const emailRegex = '[^@]+@[^@]+';

  export default {
    name: 'sc-contact',
    directives: { mask },
    data() {
      return {
        fullname: '',
        email: '',
        phone: '',
        alreadyChecked: false,
      };
    },
    methods: {
      ...mapActions([
        'stepInstallSelfService',
      ]),
      ...mapMutations([
        'nextStep',
        'setContact',
        'setLoading',
      ]),
      onChangeEmail() {
        this.email = this.email.replaceAll(' ', '');
      },
      validate() {
        this.alreadyChecked = true;
        if (this.emailValidationMessage()) {
          return false;
        }
        return true;
      },
      emailValidationMessage() {
        if (!this.email) {
          return 'O campo é obrigatório.';
        }
        if (!this.email.match(emailRegex)) {
          return 'Digite um email válido.';
        }
        return '';
      },
      executeOnFinish() {
        this.setLoading(true);
        this.setContact({
          logistic_provider_contact_name: this.fullname,
          logistic_provider_contact_email: this.email,
          logistic_provider_contact_phone_number: this.phone,
        });

        const APP_ID = this.$route.params.id;
        this.stepInstallSelfService(APP_ID)
        .then(async (result) => {
          if (result.ok) {
            this.nextStep();
          } else {
            ScToast.open({
              message: result.message,
              duration: 20000,
              type: 'is-danger',
            });
          }
        }).finally(() => this.setLoading(false));
      },
    },

    components: {
      ScButton,
      ScField,
      ScInput,
      HelpButton,
      ScToast,
    },
  };

</script>

<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 40px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 30px;
    max-width: 440px;
    & > * {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/ScContact.vue?0c646eb8